<template>
  <v-page-content>
    <div class="mx-auto main-page-content-container" v-resize="onResize">
      <div class="map-container" v-show="isMap">
        <div class="title">
          Проект «Газпром-классы»
        </div>
        <div class="map-container-map">
          <Map />
        </div>
        <div class="stat-title">
          <!--Хард код/-->
          42 класса по всей России
        </div>
      </div>
      <div class="text-center map-buttons-container d-flex justify-content-center" v-show="isMap">
        <button
          v-for="(type, index) in types"
          :key="index"
          :class="'map-button ' + (contentType === type
            ? `button-${type}-selected`
            : `button-${type}`)"
          @click="changeMapSelection(type)"
        >
          {{ tabTitles[index] }}
        </button>
      </div>
      <div class="content-without-map-container mx-auto">
        <div class="instead-of-map-container" v-show="!isMap">
          <div class="title-for-classes">
            Проект «Газпром&#8209;классы»
          </div>
          <org-collapses
            :data-for-toggles="dataForToggles"
            :toggle-type="toggleType"
            :tab-titles="tabTitles"
            :types="types"
            @toggle="changeSelectionForToggle"
          />
        </div>
        <div id="anchor-for-news" class="anchor"></div>
        <div class="mt-5">
          <h3 id="lastNewsLabel">Новости</h3>
          <template v-if="lastNews && lastNews.length">
            <div class="row" v-for="news in lastNews" :key="news.id">
              <div class="col-12 col-lg-2">
                <h4 class="d-lg-none">
                  {{ new Date(news.createdAt).toLocaleDateString() }}.
                  <span v-html="news.title"></span>
                </h4>
                <img
                  style="width:300px;"
                  :src="news.avatar ? getContentPath(news) : defaultImage"
                  @error="$event.target.src = defaultImage"
                  class="img-fluid"
                  alt=""
                />
              </div>
              <div class="col-12 col-lg-10 newsContent">
                <div>
                  <h4 class="d-none d-lg-block">
                    {{ new Date(news.createdAt).toLocaleDateString() }}.
                    <span v-html="news.title"></span>
                  </h4>
                </div>
                <div
                  v-show="news.shortDescription !== emptyText"
                  v-html="news.shortDescription"
                  class="text-justify"
                ></div>
              </div>
            </div>
          </template>
          <template v-else>
            <skeleton-news />
          </template>
        </div>
        <div id="anchor-for-events" class="anchor"></div>
        <div>
          <h3 id="lastEventsLabel">Мероприятия</h3>
          <div>
            <template v-if="lastEvents && lastEvents.length">
              <b-card-group deck class="mb-3">
                <b-card
                  v-for="event in lastEvents"
                  :key="event.id"
                  :img-src="event.avatar ? getContentPath(event) : defaultImage"
                  img-alt=""
                  img-top
                >
                  {{ new Date(event.scheduleDate).toLocaleDateString() }}.
                  <div v-html="event.title" style="display: inline-block"></div>
                </b-card>
              </b-card-group>
            </template>
            <template v-else>
              <skeleton-event />
            </template>
          </div>
        </div>
        <div id="anchor-for-tasks" class="anchor"></div>
        <div id="tasks">
          <div class="row">
            <div class="col-12">
              <h3 id="aboutProjectLabel">О проекте</h3>
              Проект выполняет следующие задачи:
              <ul class="list text-justify">
                <li>
                  формирование у&nbsp;учащихся школ представлений о&nbsp;ценности
                  инженерного труда, ранняя профессиональная ориентация
                  на&nbsp;инженерные профессии;
                </li>
                <li>
                  ознакомление с&nbsp;историей, корпоративной культурой
                  и&nbsp;перспективами развития ПАО&nbsp;«Газпром» и&nbsp;его
                  дочерних обществ, с&nbsp;нефтегазовым производством,
                  с&nbsp;особенностями специальностей и&nbsp;профессий, востребованных
                  дочерними обществами, в&nbsp;том числе с&nbsp;привлечением
                  преподавателей ВУЗов-партнеров;
                </li>
                <li>
                  мотивация учащихся для&nbsp;последующей работы в&nbsp;дочерних
                  обществах, закрепление молодежи в&nbsp;регионах деятельности
                  дочерних компаний;
                </li>
                <li>
                  повышение качества подготовки учащихся, обеспечивающей
                  их&nbsp;конкурентоспособность при поступлении в&nbsp;ВУЗы,
                  в&nbsp;том числе в&nbsp;ВУЗы-партнеры;
                </li>
                <li>
                  подготовка учащихся по&nbsp;дисциплине «Технология»,
                  а&nbsp;также по дополнительным образовательным программам,
                  имеющим целью трудовое воспитание;
                </li>
                <li>
                  создание условий для&nbsp;развития творческих способностей
                  учащихся, их&nbsp;личностного роста, профессионального
                  самоопределения и&nbsp;самореализации через формирование
                  ключевых компетенций.
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div id="anchor-for-images" class="anchor"></div>
        <div id="imagesDiv" v-if="images.length">
          <h4>Галерея</h4>
          <b-carousel
            :interval="4000"
            controls
            indicators
            background="#e4dede"
          >
            <b-carousel-slide
              v-for="(photo, index) in images"
              class="carousel-slide-container"
              :key="index"
            >
              <template #img>
                <div class="d-flex text-center h-100">
                  <img
                    :src="photo"
                    class="w-100 my-auto"
                    @error="$event.target.src = defaultImage"
                  />
                </div>
              </template>
            </b-carousel-slide>
          </b-carousel>
          <b-modal size="xl" ref="imageModal" id="imageModal">
            <img
              :src="photoForOpen"
              :width="imageWidth"
              class="mx-auto"
              style="display: block"
            />
            <template v-slot:modal-footer="{}">
              <div class="text-center w-100">
                <b-button-group>
                  <b-button @click="gotoPhoto(-1)" variant="primary">
                    <em class="fas fa-angle-left"></em>
                  </b-button>
                  <b-button @click="gotoPhoto(1)" variant="primary">
                    <em class="fas fa-angle-right"></em>
                  </b-button>
                </b-button-group>
              </div>
            </template>
          </b-modal>
        </div>
      </div>
    </div>
  </v-page-content>
</template>


<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import resize from 'vue-resize-directive'
import _ from 'lodash'
import { emptyShortDescription } from '@/config/config'
import Map from '@/components/main-page/map/index.vue'
import OrgCollapses from '@/components/main-page/OrgCollapses.vue'
import SkeletonEvent from '@/components/ui/skeleton/SkeletonEvent.vue'
import SkeletonNews from '@/components/ui/skeleton/SkeletonNews.vue'
import GalleryAPI from '@/api/gallery'

const schoolsCases = {
  one: 'Школа',
  few: 'Школы',
  many: 'Школ'
}


export default {
  name: 'MainPage',
  directives: {
    resize
  },
  components: {
    SkeletonNews,
    SkeletonEvent,
    OrgCollapses,
    Map
  },
  data() {
    return {
      emptyText: emptyShortDescription,
      contentType: 'classes',
      toggleType: null,
      schoolsCount: 0,
      carouselStyle: {
        height: '300px',
        width: '100%'
      },
      carouselShowElements: [[0, 1], [720, 2]],
      photoForOpen: null,
      imageWidth: null,
      classes: null,
      dataForToggles: null,
      images: [],
      contentCountOnPage: 3,
      defaultImage: '/images/w1400_1.jpg',
      windowWidth: 0,
      selectedIndex: null,
      hoverIndex: null,
      isMap: true,
      types: ['classes', 'univers', 'fields'],
      functionForType: {
        classes: this.fetchGPClasses,
        univers: this.fetchAllPartners,
        fields: this.fetchGPFields
      },
      tabTitles: ['Газпром-классы', 'Вузы-партнеры ПАО «Газпром», Частные профессиональные образовательные учреждения ПАО «Газпром»', 'Месторождения']
    }
  },
  async mounted() {
    this.onResize()
    this.windowWidth = window.innerWidth
    window.onresize = async () => {
      await this.checkPhotoSize(document.documentElement)
    }
    window.addEventListener('keyup', (event) => {
      if (
        this.photoForOpen !== null
        && this.$refs.imageModal
        && !this.$refs.imageModal.isHidden
      ) {
        if (event.key === 'ArrowRight') {
          this.gotoPhoto(1)
        } else if (event.key === 'ArrowLeft') {
          this.gotoPhoto(-1)
        }
      }
    })
    this.fetchEvents({
      pages: {
        perPage: this.contentCountOnPage,
        pageNumber: 1,
        filters: [{ param: 'status', needle: ['опубликовано'] }]
      },
      withoutClassEvents: true
    })
    this.fetchNews({
      perPage: this.contentCountOnPage,
      pageNumber: 1,
      filters: [{ param: 'status', needle: ['опубликовано'] }]
    })

    this.fetchGPClasses().then(() => {
      let addresses = []
      this.gpClasses.filter((c) => c.position).forEach((gpc) => {
        addresses = _.uniq([gpc.address, ...addresses])
      })
      this.schoolsCount = addresses.length - this.gpClasses
        .filter((cl) => cl.disabledAsSchool && cl.position).length
    })
    this.images = (await GalleryAPI.getGalleryFiles()).data.files.map((f) => `/api/files/${f.file.physicalName}`)
    for (let i = 3; i <= this.images.length; i++) {
      this.carouselShowElements.push([300 * i + 20 + 100 * i, i])
    }
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize)
    })
  },
  beforeDestroy() {
    this.setEvents([])
    this.setNews([])
  },
  methods: {
    ...mapActions({
      fetchEvents: 'content/fetchEvents',
      fetchNews: 'content/fetchNews',
      fetchGPClasses: 'content/fetchGPClassesForMap',
      fetchAllPartners: 'content/fetchAllPartnersForMap',
      fetchGPFields: 'content/fetchGPFields'
    }),
    ...mapMutations({
      setEvents: 'content/setEvents',
      setNews: 'content/setNews'
    }),
    gotoPhoto(delta) {
      const index = this.images.indexOf(this.photoForOpen)
      let newIndex = (index + delta) % this.images.length
      if (newIndex < 0) {
        newIndex += this.images.length
      }
      this.showPhotoModal(newIndex)
    },
    changeSelectionForToggle(type) {
      const data = this.dataForType[type]
      this.dataForToggles = data.filter((c) => c.position)
      if (this.toggleType === type) {
        this.$root.$emit('bv::toggle::collapse', 'collapse-for-classes')
        this.toggleType = null
      } else {
        if (!this.toggleType) {
          this.$root.$emit('bv::toggle::collapse', 'collapse-for-classes')
        }
        this.toggleType = type
        this.changeMapSelection(type)
      }
    },
    changeMapSelection(type) {
      if (type === this.contentType) {
        return
      }
      const functionFetch = this.functionForType[type]
      functionFetch().then(() => {
        this.contentType = type
        if (this.toggleType) {
          const array = this.dataForType[type]
          this.dataForToggles = array.filter((c) => c.position)
        }
      })
    },
    checkPhotoSize(wind) {
      if (this.photoForOpen) {
        const img = new Image()
        img.src = this.photoForOpen
        const widthBefore = img.naturalWidth
        const height = img.naturalHeight
        this.imageWidth = widthBefore
        if (
          wind.clientWidth * 0.8 < widthBefore
          || this.imageWidth > 1130
          || wind.clientWidth < 976
        ) {
          this.imageWidth = '100%'
        }
        if (height && height > wind.clientHeight * 0.85 - 130) {
          const proportions = widthBefore / height
          const newWidth = proportions * (wind.clientHeight * 0.85 - 140)
          if (
            (this.imageWidth !== '100%' && newWidth < this.imageWidth)
            || (wind.clientWidth > 1178 && newWidth < 1106)
            || (wind.clientWidth > 975 && newWidth < 776)
            || (wind.clientWidth > 460 && newWidth < 466)
          ) {
            this.imageWidth = newWidth
          }
        }
      }
    },
    async showPhotoModal(photoId) {
      this.photoForOpen = this.images[photoId]
      await this.checkPhotoSize(document.documentElement)
      await this.$refs.imageModal.show()
    },
    onResize() {
      this.windowWidth = window.innerWidth
      const mapContainer = document.getElementsByClassName('main-page-content-container').length
        ? document.getElementsByClassName('main-page-content-container')[0]
        : null
      this.isMap = mapContainer && mapContainer.clientWidth >= 1093
    },
    getContentPath(event) {
      const file = event.files.find((p) => p.id === event.avatar)
      return file ? `/api/files/${file.physicalName}` : this.defaultImage
    }
  },
  computed: {
    ...mapGetters({
      lastEvents: 'content/getEvents',
      lastNews: 'content/getNews',
      gpClasses: 'content/getGPClasses',
      gpUnivers: 'content/getAllPartners',
      gpFields: 'content/getGPFields'
    }),
    dataForType() {
      return {
        classes: this.gpClasses,
        univers: this.gpUnivers,
        fields: this.gpFields
      }
    },
    schoolsNoun() {
      return schoolsCases[new Intl.PluralRules('ru').select(this.schoolsCount)]
    }
  }
}
</script>

<style scoped lang="scss">
body,
html {
  /*font: 300 16px/1.5 Roboto,sans-serif;*/
  font-family: 'PT Sans', sans-serif;
  height: 100%;
}

html {
  scroll-behavior: smooth;
}


#tasks {
  padding-top: 50px;
  background-color: #f8f9fa;

  padding-bottom: 50px;
  font-size: 16px;

  /*background-image: url(images/w1400_1_2.png);*/
  /*background-size: 600px;*/
  /*background-repeat: no-repeat;*/
  /*background-position-x: right;*/
}


.map-button {
  flex-grow: 1;
  flex-basis: 300px;
  font-family: Roboto, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  padding: 8px 0;
}

.button-classes-selected {
  background: #0078C1;
  border: 1px solid #0078C1;
  border-radius: 6px 0 0 6px;
  color: white;
}
.button-fields {
  background: white;
  border: 1px solid #0078C1;
  box-sizing: border-box;
  border-radius: 0 6px 6px 0;
  color: #0078C1;
}
.button-fields-selected {
  background: #0078C1;
  border: 1px solid #0078C1;
  border-radius: 0 6px 6px 0;
  color: white;
}
.button-univers {
  background: white;
  border: 1px solid #0078C1;
  border-left: none;
  border-right: none;
  box-sizing: border-box;
  border-radius: 0;
  color: #0078C1;
}

.button-univers-selected {
  background: #0078C1;
  border: 1px solid #0078C1;
  border-radius: 0;
  color: white;
}
.button-classes {
  background: #FFFFFF;
  border: 1px solid #0078C1;
  box-sizing: border-box;
  border-radius: 6px 0 0 6px;
  color: #0078C1;
}
.button-classes:hover,
.button-fields:hover,
.button-univers:hover {
  background: #ECF8FF;
  border: 1px solid #0078C1;
  color: #0078C1;
}
.button-classes-selected:hover,
.button-fields-selected:hover,
.button-univers-selected:hover {
  border: 1px solid #0078C1;
  background: #0078C1;
  color: white;
}
#lastNewsLabel {
  padding-bottom: 20px;
}

.row {
  margin-bottom: 25px;
}

.newsContent {
  position: relative;
}
.carouselPhoto:hover {
  box-shadow: 0 0 10px 0 rgba(1, 122, 195, 0.6),
    0 0 6px 0 rgba(1, 122, 195, 0.8);
}

.stat-title {
  position: absolute;
  bottom: 0;
  right: 0;
  padding: 22px 28px;
  background-color: #0078c1;
  color: white;
  font-family: Roboto, sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 30px;
  line-height: 35px;
  z-index: 1;
}
.map-container {
  position: relative;
  top: 45px;
}

.title {
  position: absolute;
  top: -42px;
  left: 0px;
}
.title-for-classes,
.title {
  padding: 20px 28px;
  background-color: #0078c1;
  color: white;
  font-family: Roboto, sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 32px;
  line-height: 37px;
  z-index: 1;
  display: inline-block;
}

@media screen and (max-width: 400px) {
  .title-for-classes {
    font-size: 30px;
    padding: 20px 10px;
  }
}

.anchor {
  margin-top: -80px;
  padding-top: 80px;
}
.map-buttons-container {
  margin-top: 80px;
}
.main-page-content-container {
  max-width: 1164px;
}
.content-without-map-container {
  max-width: 1024px;
}
.carousel-slide-container {
  position: relative;
  height: 520px;
  img {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
@media screen and (max-width: 800px) {
  .carousel-slide-container {
    height: 320px;
  }
}

@media screen and (max-width: 540px) {
  .carousel-slide-container {
    height: 240px;
  }
}

</style>
